<template>
  <div id="content">
    <progressive-img
      id="landing-img"
      src="/images/0023.jpg"
      placeholder="/images/output-23.jpg"
    />
    <div id="contact">
      <address>
        <a href="mailto:mccarthy.interiors@mac.com">
          mccarthy.interiors@mac.com</a
        ><br />
        (416) 277-2646<br />
        717 Wendy Culbert Cres<br />
        Newmarket, ON<br />
        L3X 0E9
      </address>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Home"
  };
</script>

<style scoped>
  #content {
    margin: auto;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  #landing-img {
    width: 100%;
    max-width: 960px;
  }

  #contact {
    width: 100%;
    text-align: left;
    line-height: 1.5rem;
    display: flex;
    justify-content: center;
  }

  @media screen and (min-width: 1200px) {
    #content {
      width: 40%;
      padding: 80px 0px 0px 0px;
    }
    #contact {
      font-size: large;
      line-height: 2rem;
    }
  }

  @media screen and (min-width: 700px) and (max-width: 1200px) {
    #content {
      width: 60%;
      padding: 40px 0px 0px 0px;
    }
    #contact {
      font-size: medium;
      line-height: 1.5rem;
    }
  }

  @media screen and (max-width: 700px) {
    #content {
      padding: 0px 0px 0px 0px;
      width: 80%;
      flex-wrap: wrap;
    }
    #landing-img {
      width: 100%;
    }
    #contact {
      width: 100%;
      font-size: small;
      line-height: 1rem;
      padding-top: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue